import DateFormatter from '../plugins/php-date-formatter';

let dateFormatter = new DateFormatter();

document.querySelectorAll('.js-date').forEach(function (item) {
	if (item.dataset.timestamp && item.dataset.format) {
		let date = new Date(item.dataset.timestamp * 1000);
		let formattedDate = dateFormatter.formatDate(date, item.dataset.format);
		item.innerHTML = formattedDate;
		item.title = formattedDate;
	}
});
